// src/components/ProfileEditor.js
import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import './ProfileEditor.css';

const ProfileEditor = () => {
    const { userProfile, updateUserProfile } = useAuth();
    const [formData, setFormData] = useState({
        nome: '',
        sobrenome: '',
        telefone: '',
        cpfCnpj: '',
        rua: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
    });
    const [isLoading, setIsLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState('');

    useEffect(() => {
        if (userProfile) {
            const nameParts = userProfile.nome ? userProfile.nome.split(' ') : [''];
            const nome = nameParts.shift() || '';
            const sobrenome = nameParts.join(' ');

            setFormData({
                nome: nome,
                sobrenome: sobrenome,
                telefone: userProfile.telefone || '',
                cpfCnpj: userProfile.cpfCnpj || '',
                rua: userProfile.rua || '',
                numero: userProfile.numero || '',
                complemento: userProfile.complemento || '',
                bairro: userProfile.bairro || '',
                cidade: userProfile.cidade || '',
                estado: userProfile.estado || '',
                cep: userProfile.cep || '',
            });
        }
    }, [userProfile]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setSuccessMessage('');

        const profileDataToUpdate = {
            ...formData,
            nome: `${formData.nome} ${formData.sobrenome}`.trim(),
        };

        try {
            await updateUserProfile(profileDataToUpdate);
            setSuccessMessage('Seus dados foram atualizados com sucesso!');
        } catch (error) {
            console.error("Erro ao atualizar perfil:", error);
            alert('Ocorreu um erro ao salvar seus dados.');
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="profile-editor-container">
            <h3>Meus Dados</h3>
            <p>Mantenha suas informações de contato e endereço sempre atualizadas.</p>
            <form onSubmit={handleSubmit} className="profile-form">
                <div className="form-group-grid">
                    <div className="form-group-profile"><label>Nome *</label><input type="text" name="nome" value={formData.nome} onChange={handleChange} required /></div>
                    <div className="form-group-profile"><label>Sobrenome</label><input type="text" name="sobrenome" value={formData.sobrenome} onChange={handleChange} /></div>
                    <div className="form-group-profile full-span"><label>Telefone *</label><input type="text" name="telefone" value={formData.telefone} onChange={handleChange} required /></div>
                    <div className="form-group-profile full-span"><label>CPF ou CNPJ *</label><input type="text" name="cpfCnpj" value={formData.cpfCnpj} onChange={handleChange} required /></div>
                    <div className="form-group-profile full-span"><label>Endereço (Rua, Av.)</label><input type="text" name="rua" value={formData.rua} onChange={handleChange} /></div>
                    <div className="form-group-profile"><label>Número</label><input type="text" name="numero" value={formData.numero} onChange={handleChange} /></div>
                    <div className="form-group-profile"><label>Complemento</label><input type="text" name="complemento" value={formData.complemento} onChange={handleChange} /></div>
                    <div className="form-group-profile full-span"><label>Bairro</label><input type="text" name="bairro" value={formData.bairro} onChange={handleChange} /></div>
                    <div className="form-group-profile"><label>Cidade</label><input type="text" name="cidade" value={formData.cidade} onChange={handleChange} /></div>
                    <div className="form-group-profile"><label>Estado</label><input type="text" name="estado" value={formData.estado} onChange={handleChange} /></div>
                    <div className="form-group-profile full-span"><label>CEP</label><input type="text" name="cep" value={formData.cep} onChange={handleChange} /></div>
                </div>
                <button type="submit" className="save-button" disabled={isLoading}>
                    {isLoading ? 'Salvando...' : 'Salvar Alterações'}
                </button>
                {successMessage && <p className="success-message">{successMessage}</p>}
            </form>
        </div>
    );
};

export default ProfileEditor;